import cn from 'classnames';
import { HTMLAttributes } from 'react';

import styles from './index.module.sass';

export function UiIcon(props: IUiIconProps) {
  const { className, icon, ...rest } = props;
  const rootClass = cn(className, styles.root);

  return (
    <span className={rootClass} {...rest}>
      {icon}
    </span>
  );
}

export interface IUiIconProps
  extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  icon: JSX.Element;
}
